import withRegistrarDocente from "../../hoc/Docentes/withRegistrarDocente";
import RegistroDocente from "../../view/components/RegistroUsuarios/RegistroUsuarios";

export default withRegistrarDocente(RegistroDocente)